var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTennis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_80_16115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.99986 17.64C13.7716 17.64 17.6399 13.7717 17.6399 9C17.6399 4.22826 13.7716 0.360001 8.99986 0.360001C4.22812 0.360001 0.359863 4.22826 0.359863 9C0.359863 13.7717 4.22812 17.64 8.99986 17.64Z",
    fill: "#8FC73F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1118 5.148C14.6158 4.5 15.0118 3.816 15.2638 3.06C14.9758 2.772 14.6878 2.484 14.3638 2.232C14.1838 3.024 13.7878 3.78 13.2478 4.428C11.5558 6.516 11.0518 9.396 12.4198 11.844C13.3198 13.464 13.0678 15.516 11.9878 17.064C12.5638 16.848 13.1038 16.596 13.6438 16.236C14.2558 14.616 14.2198 12.816 13.3918 11.268C12.2758 9.36 12.6718 6.912 14.1118 5.148Z",
    fill: "#F0E7CE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M13.5 4.464C11.808 6.552 11.304 9.432 12.672 11.88C13.572 13.464 13.32 15.444 12.312 16.992L11.988 17.1C13.068 15.552 13.32 13.5 12.42 11.88C11.052 9.432 11.592 6.552 13.248 4.464C13.788 3.816 14.184 3.024 14.364 2.268C14.436 2.304 14.472 2.376 14.544 2.412C14.364 3.132 14.004 3.852 13.5 4.464Z",
    fill: "#071123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.06776 1.908C3.67176 2.16 3.31176 2.484 2.98776 2.808C3.05976 3.6 3.27576 4.356 3.63576 5.004C4.75176 6.984 4.35576 9.432 2.87976 11.196C2.30376 11.88 1.87176 12.672 1.65576 13.536C1.90776 13.932 2.19576 14.328 2.48376 14.688C2.62776 13.68 3.05976 12.708 3.70776 11.88C5.39976 9.792 5.90376 6.876 4.57176 4.464C4.13976 3.744 3.95976 2.844 4.06776 1.908Z",
    fill: "#F0E7CE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M3.02376 11.52C2.48376 12.204 2.05176 12.96 1.76376 13.752C1.72776 13.68 1.69176 13.644 1.65576 13.572C1.90776 12.744 2.33976 11.952 2.87976 11.232C4.31976 9.432 4.71576 7.02 3.63576 5.04C3.27576 4.356 3.02376 3.6 2.98776 2.844L3.16776 2.664C3.27576 3.384 3.49176 4.104 3.85176 4.752C5.07576 6.876 4.60776 9.54 3.02376 11.52ZM17.6398 9C17.6398 13.788 13.7518 17.64 8.99976 17.64C6.26376 17.64 3.77976 16.344 2.23176 14.364C3.70776 15.516 5.54376 16.2 7.55976 16.2C12.3478 16.2 16.1998 12.348 16.1998 7.56C16.1998 5.544 15.5158 3.672 14.3278 2.232C16.3438 3.78 17.6398 6.264 17.6398 9Z",
    fill: "#071123"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M14.8319 5.796C14.8319 10.692 10.6919 14.688 5.57986 14.688C4.28386 14.688 3.05986 14.436 1.97986 14.004C0.899863 12.492 0.359863 10.764 0.359863 9C0.359863 4.212 4.21186 0.360001 8.99986 0.360001C10.1879 0.360001 11.2679 0.576001 12.3119 1.008C12.8519 1.224 13.3919 1.512 13.8959 1.872C14.4719 3.06 14.8319 4.392 14.8319 5.796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M12.7439 3.708C12.7439 8.604 8.60386 12.6 3.45586 12.6C2.59186 12.6 1.76386 12.492 1.00786 12.276C0.575863 11.268 0.359863 10.152 0.359863 9C0.359863 4.212 4.21186 0.360001 8.99986 0.360001C10.1879 0.360001 11.2679 0.576001 12.3119 1.008C12.5999 1.872 12.7439 2.772 12.7439 3.708Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M8.02254 8.20784C9.80799 6.42233 10.3094 4.02895 9.14251 2.86209C7.9756 1.69522 5.58225 2.19673 3.7968 3.98224C2.01135 5.76775 1.50993 8.16112 2.67684 9.32799C3.84374 10.4949 6.2371 9.99334 8.02254 8.20784Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_80_16115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTennis);
export default __webpack_public_path__ + "static/media/tennis.d66d39c9934df0ff719b151653d86e68.svg";
export { ForwardRef as ReactComponent };